import { render } from "./WiseUserEditForm.vue?vue&type=template&id=07f70b2a"
import script from "./WiseUserEditForm.vue?vue&type=script&lang=js"
export * from "./WiseUserEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__